import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import LandingPage from "@/components/LandingPage";
import ResultsPage from "@/components/ResultsPage";
import AdminDashboard from "@/components/AdminDashboard";
import LeaderboardPage from "@/components/LeaderboardPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function AuditApp() {
  const [step, setStep] = useState("landing");
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [lastForm, setLastForm] = useState(null);

  const handleAuditSubmit = async (formData) => {
    setLoading(true);
    setError("");
    setLastForm(formData);
    try {
      const res = await axios.post(`${API}/audit`, formData);
      if (res.data.error) {
        setError(res.data.error);
        setLoading(false);
        return;
      }
      setResult(res.data);

      // Fetch history for this URL
      try {
        const histRes = await axios.get(`${API}/audit/history`, { params: { url: formData.url } });
        setHistory(histRes.data);
      } catch {
        setHistory(null);
      }

      setStep("results");
    } catch (e) {
      console.error("Audit failed:", e);
      setError("Something went wrong. Please check the URL and try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRescan = () => {
    if (lastForm) {
      handleAuditSubmit(lastForm);
      setStep("landing");
    }
  };

  const handleQuizSubmit = async (leadId, answers) => {
    try {
      await axios.post(`${API}/quiz/submit`, { lead_id: leadId, answers });
    } catch (e) {
      console.error("Quiz submit failed:", e);
    }
  };

  if (step === "landing") {
    return <LandingPage onSubmit={handleAuditSubmit} loading={loading} error={error} />;
  }
  if (step === "results" && result) {
    return (
      <ResultsPage
        result={result}
        history={history}
        onQuizSubmit={handleQuizSubmit}
        onRescan={handleRescan}
        rescanLoading={loading}
      />
    );
  }
  return <LandingPage onSubmit={handleAuditSubmit} loading={loading} error={error} />;
}

function AdminWrapper() {
  const navigate = useNavigate();
  return <AdminDashboard onBack={() => navigate("/")} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuditApp />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/admin" element={<AdminWrapper />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
